export default "__VITE_ASSET__Ccrr4H$m__"